"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "monreale": {
    "fc6f8b8a": [{
      "hkey": "c68dc58f",
      "slug": "centro-aquino",
      "name": "Centro-Aquino",
      "primary": true,
      "skipSearch": false
    }],
    "aquino": [{
      "hkey": "c68dc58f",
      "slug": "centro-aquino",
      "name": "Centro-Aquino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "189dccc9": [{
      "hkey": "ca4ee434",
      "slug": "pioppo-giacalone",
      "name": "Pioppo-Giacalone",
      "primary": true,
      "skipSearch": false
    }],
    "pioppo": [{
      "hkey": "ca4ee434",
      "slug": "pioppo-giacalone",
      "name": "Pioppo-Giacalone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;